export type OperationsResponse = Array<OperationsContentItem>;

export type OperationsContentItem = {
  keycloakId: string;
  officerName: string;
  rank: string;
  officerNumber: string;
  lastLoginDateTime?: string;
  lastSubmitDateTime?: string;
  lastCitationDateTime?: string;
  lastWarningDateTime?: string;
  last7DaysCitationsCount: number;
  last7DaysWarningsCount: number;
  last30DaysCitationsCount: number;
  last30DaysWarningsCount: number;
  totalCitationsCount: number;
  totalWarningsCount: number;
};

export type OperationsTableColumn = {
  columnDef: OperationsColumn;
  header: string;
  cell: (value: OperationsContentItem) => string;
  sortDef?: string;
};

export type OperationsDialogColumn = {
  columnDef: OperationsColumn;
  title: string;
  checkboxDisabled?: boolean;
};

export enum OperationsColumn {
  OfficerName = 'officerName',
  Rank = 'rank',
  Badge = 'officerNumber',
  LastLoginDT = 'lastLoginDateTime',
  LastCitationDT = 'lastCitationDateTime',
  LastWarningDT = 'lastWarningDateTime',
  TotalCitations = 'totalCitationsCount',
  TotalWarnings = 'totalWarningsCount',
  Last7DaysCitations = 'last7DaysCitationsCount',
  Last30DaysCitations = 'last30DaysCitationsCount',
  Last7DaysWarnings = 'last7DaysWarningsCount',
  Last30DaysWarnings = 'last30DaysWarningsCount',
}
